import { CSSProperties } from "react"
import { Transform } from "@dnd-kit/utilities"

export const MONTH_CARD_BORDER_RADIUS = 6
export const MONTH_CARD_COLOR_STRIP_WIDTH = 8

type MonthCardStyleParams = {
  color: string
  isDragging: boolean
  transform: Transform | null
}

type MonthCardStyles = {
  outerStyle: CSSProperties
  innerStyle: CSSProperties
}

export const getMonthCardStyles = ({ color, isDragging, transform }: MonthCardStyleParams): MonthCardStyles => ({
  outerStyle: {
    marginBottom: 2,
    backgroundColor: color,
    borderRadius: MONTH_CARD_BORDER_RADIUS,
    cursor: isDragging ? 'grabbing' : 'pointer',
    overflow: 'hidden',
    position: 'relative',
    zIndex: isDragging ? 100 : undefined,
    transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
  },
  innerStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    padding: '4px 8px',
    margin: `1px 1px 1px ${MONTH_CARD_COLOR_STRIP_WIDTH}px`,
    backgroundColor: '#ffffff',
    borderRadius: MONTH_CARD_BORDER_RADIUS,
  },
})
